import { PageHero } from "@/components/landing/PageHero";
import { AIModules } from "@/components/landing/AIModules";
import { ClinicOSIntelligence } from "@/components/landing/ClinicOSIntelligence";
import { ConversationIntelligence } from "@/components/landing/ConversationIntelligence";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { PainPoints, GROWTH_STATS } from "@/components/welcome/PainPoints";
import { DiscChapters } from "@/components/welcome/DiscChapters";
import { AI_WORKFORCE_CHAPTERS } from "@/data/discChapters";

export default function AIWorkforce() {
  return (
    <>
      <PageHero
        overline="AI Workforce"
        title="An AI team that"
        highlight="never clocks out"
        subtitle="A virtual receptionist and Copilot working alongside your front desk — answering calls, booking appointments, replying across channels and driving reactivations 24/7."
      />
      <div className="pt-2 sm:pt-6">
        <PainPoints
          eyebrow="The capacity problem"
          heading="An AI workforce gives you 2-3 extra staff — without payroll."
          sub="The numbers driver-style owners actually care about. Industry on the left. Clinic OS on the right."
          stats={GROWTH_STATS}
        />
        <DiscChapters
          eyebrow="AI Workforce, four ways"
          heading="Same AI Workforce. Four reasons to hire it."
          sub="Capacity, tone, calm rollout, audit-grade — pick the chapter that matches your concern."
          chapters={AI_WORKFORCE_CHAPTERS}
        />
      </div>
      <AIModules />
      <ClinicOSIntelligence />
      <ConversationIntelligence />
      <FinalCTA />
    </>
  );
}
